export const COUNTRIES = [
  'Argentina',
  'Bolivia',
  'Brasil',
  'Chile',
  'Colombia',
  'Costa Rica',
  'Cuba',
  'Ecuador',
  'El Salvador',
  'Guatemala',
  'Haití',
  'Honduras',
  'México',
  'Nicaragua',
  'Panamá',
  'Paraguay',
  'Perú',
  'Puerto Rico',
  'República Dominicana',
  'Uruguay',
  'Venezuela'
]
export const PROFESSIONS = [
  'ENFERMERA/O',
  'MÉDICO',
  'PROFESIONAL DE LABORATORIO',
  'QUÍMICO FARMACÉUTICO'
]
export const POSTGRADES = [
  'DOCTORADO',
  'ESPECIALIDAD',
  'MAESTRÍA',
  'MBA',
  'POSDOCTORADO'
]
export const SPECIALTIES = [
  'ANESTESIA',
  'AUDITOR',
  'BIOLOGÍA MOLECULAR',
  'CIRUGÍA GENERAL',
  'DERMATOLOGÍA',
  'ENDOCRINOLOGÍA',
  'EPIDEMIOLOGÍA',
  'FARMACÉUTICO CLÍNICO',
  'FARMACÉUTICO OPERACIONAL',
  'GASTROENTEROLOGÍA',
  'GINECOLOGÍA Y OBSTETRICIA',
  'MEDICINA INTERNA',
  'MICROBIOLOGÍA',
  'NUTRICIÓN',
  'ORTOPEDIA Y TRAUMATOLOGÍA',
  'PATOLOGÍA CLÍNICA',
  'PEDIATRÍA',
  'QUÍMICO FARMACOBILÓGICO'
]
export const SUBSPECIALTIES = [
  'CARDIOLOGÍA',
  'CIRUGIA DE CABEZA Y CUELLO',
  'CIRUGÍA VASCULAR',
  'CUIDADO INTENSIVO',
  'EMERGENCIOLOGÍA',
  'GASTROENTEROLOGÍA',
  'GERIATRIA',
  'HEMATOLOGÍA',
  'INFECTOLOGÍA',
  'MEDICINA NUCLEAR',
  'NEFROLOGIA',
  'NEONATOLOGÍA',
  'NEUMOLOGÍA',
  'ONCOLOGÍA',
  'REUMATOLOGÍA'
]
export const EXPERTICES = [
  'ACCESOS VASCULARES',
  'AFERESIS TERAPÉUTICA',
  'CIRUGÍA ONCOLÓGICA',
  'CIRUGÍA VASCULAR',
  'ECMO',
  'ECONOMÍA DE LA SALUD',
  'HEMATOLOGÍA',
  'INFECCIONES',
  'LABORATORIO CLÍNICO',
  'NUTRICIÓN',
  'ONCOLOGÍA',
  'PEDIATRÍA - NEONATOLOGÍA',
  'PROCESOS FARMACÉUTICOS'
]
export const PROFILES = ['INVESTIGADOR', 'SPEAKER', 'ASESOR']
export const LANGUAGES = ['ESPAÑOL', 'INGLÉS', 'PORTUGUÉS']
export const COURSEG = ['SI', 'NO']
export const UNITIES = ['MDS', 'BDB', 'MMS', 'IDS']
export const CATEGORIES = ['LOCAL', 'REGIONAL', 'GLOBAL']
